
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FormItemProps } from ".";
import { loading, endLoading } from "store/form";

interface ApiFormRemoveInputProps {
    ids: number[]
}

type ApiFormRemoveOutputProps = OutputBaseProps<{ item: FormItemProps; }>

export const apiFormRemove = async (data: ApiFormRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiFormRemoveOutputProps>("/api/form/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};